/**
 * Constants and the module-level event bus shared by more than one rankings mixin.
 */

// Fired by Sorting once pending row fragments have been inserted into the table
export const dsEventBus = new EventTarget();

export const DEFAULT_LOADING_TEXT = 'Customizing     Scoring...'.split('');

// In-season pages that flag each player's roster status (Mine / Free) for the selected user league
export const ROSTER_STATUS_BASE_PATHS = ['weekly-rankings', 'ros-rankings'];
